<template>
    <v-app-bar :height="heightComputed" class="navbar" app :light="!dark" :dark="dark" flat :class="{'status-overlay-navbar': statusBarOverlay, scrolled: isScrolled, welcome: $route.name === 'welcome', 'p-absolute transparent': registerPages}">
        <div class="w-100" :class="{'fill-height': !statusBarOverlay, 'd-flex flex-column': statusBarOverlay}">
            <div v-if="statusBarOverlay" class="status-overlay px-3 d-flex flex-row-reverse align-center w-100 mb-1" :style="`height: ${statusBarInsetPx}px`">
                <template v-if="!isProduction">
                    <v-spacer></v-spacer>
                    <v-icon small class="ms-1">mdi-wifi-strength-4</v-icon>
                    <v-icon small class="ms-1">mdi-signal-cellular-outline</v-icon>
                    <v-icon small class="ms-1">mdi-battery</v-icon>
                    <span class="details-text me-1">12:30</span>
                </template>
            </div>
            <v-container class="d-flex py-0 fill-height" :class="{'px-1': !statusBarOverlay, 'px-4': statusBarOverlay}">
                <template v-if="!registerPages && !($route.name === 'welcome' && capRunning)">
                    <!-- <transition name="fade-transition" mode="out-in"> -->
                        <div v-if="!showSearch" class="d-flex w-100 fill-height align-center flex-row-reverse" :key="0">
                            <div class="d-flex align-center">
                                <v-btn v-haptic v-if="phoneOnly" icon color="text" @click="showSearch = true" style="margin-left: -10px">
                                    <!-- <v-icon size="26">mdi-magnify</v-icon> -->
                                    <svg class="w-6 h-6" style="width: 24px" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                                </v-btn>
                                <template v-if="isAuthed">
                                    <notifications-menu />
                                    <div class="ms-1 d-flex align-center">
                                        <v-btn v-if="$route.meta.backButton" icon :style="`margin-${$vuetify.rtl ? 'left' : 'right'}: -12px;`" @click="goBack">
                                            <v-icon>mdi-arrow-{{$vuetify.rtl ? 'left' : 'right'}}</v-icon>
                                        </v-btn>
                                        <user-nav v-else :name="user.name" :avatar="user.avatar" />
                                    </div>
                                </template>
                                <div v-else-if="pcOnly" class="d-flex align-center">
                                    <!-- <avatar :to="{name: 'login'}" :size="30" :icon-size="25"/> -->

                                    <v-btn :to="{name: 'login'}" color="primary darken-1" depressed outlined text class="me-3">Login</v-btn>
                                    <v-btn :to="{name: 'register'}" color="primary darken-1" depressed>Register</v-btn>
                                </div>
                            </div>
                            <v-spacer />

                            <!-- <div v-if="pcOnly" class="ms-6">
                                <form @submit.prevent="searchCourses">
                                    <v-text-field v-model="searchQuery" ref="searchInput" label="البحث في الدورات" prepend-inner-icon="mdi-magnify" solo dense clearable background-color="grey lighten-4" flat rounded hide-details ></v-text-field>
                                </form>
                            </div> -->

                            <div v-if="permanentMenu" class="strong-text--text">
                                {{$route.meta.title || ''}}
                            </div>
                            <div v-else class="d-flex align-center">
                                <v-btn v-haptic large icon @click.prevent="$emit('menu')" class="me-1" style="margin-right: -10px">
                                    <v-icon size="24">mdi-menu</v-icon>
                                </v-btn>
                                
                                <div class="d-flex align-center justify-center">
                                    <logo v-if="!capRunning || ['home', 'course'].includes($route.name)" height="50"/>
                                    <v-toolbar-title v-else style="font-size: 1rem">{{$route.meta.title}}</v-toolbar-title>
                                </div>
                            </div>
                        </div>
                        <div v-else class="d-flex align-center justify-space-between w-100" :key="1">
                            <form @submit.prevent="searchCourses" class="w-100">
                                <v-text-field v-model="searchQuery" autofocus ref="searchInput" label="البحث في الدورات" max-width="100%" solo dense background-color="surface" flat hide-details ></v-text-field>
                            </form>
                            <v-btn v-haptic icon @click="showSearch = false" style="margin-left: -10px">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    <!-- </transition> -->
                </template>
            </v-container>
        </div>
        <transition name="fade-transition">
            <v-progress-linear v-if="linearLoading" :active="linearLoading" :indeterminate="linearLoading" height="2" background-color="transparent" absolute bottom color="secondary" ></v-progress-linear>
        </transition>

    </v-app-bar>
</template>

<script>
import GlobalComputed, { computeEffectiveNavbarHeight } from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import NotificationsMenu from './notifications-menu'

// import Avatar from '../../default/avatar'
import UserNav from './user-nav'


export default {
    props: {
        height: {
            default: 60,
            type: Number
        },
        dark: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            isScrolled: false,

            searchQuery: '',
            showSearch: false,
        }
    },
    components: {
        NotificationsMenu,
        UserNav,
        // Avatar,
    },
    watch: {
        
    },
    computed: {
        permanentMenu(){
            return this.pcOnly && this.isAuthed && !this.$route.meta.temporaryMenu;
        },
        heightComputed(){
            return computeEffectiveNavbarHeight(this.height, {
                phoneOnly: this.phoneOnly,
                statusBarOverlay: this.statusBarOverlay,
                statusBarInsetPx: this.statusBarInsetPx,
                isRegisterPage: this.registerPages,
            });
        },
        linearLoading(){
            return this.$store.state.globalModule.linearLoading;  
        },
        registerPages(){
            return ['login', 'register', 'reset-password'].includes(this.$route.name);
        },
        ...GlobalComputed
    },
    methods: {
        searchCourses(){
            if (this.searchQuery){
                this.$router.push({name: 'courses', query: {search: this.searchQuery}});
            }
        },
        handleScroll(event){
            if (window.scrollY === 0){
                this.isScrolled = false;
            }else if (!this.isScrolled){
                this.isScrolled = true;
            }
        },
        ...GlobalMethods
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
}
</script>

<style lang="scss" scoped>
    .navbar{
        background-color: #fff!important;
        transition: all 0.2s ease!important;
        
        &.scrolled, &:not(.welcome){
            // box-shadow: 0 1px 4px 0 rgba(0,0,0, .1)!important;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }

        &.theme--dark{
            background-color: #101010!important;
        }

        &.transparent{
            background-color: unset!important;
            box-shadow: none!important;
        }
        &.p-absolute{
            position: absolute;
        }
        /* .status-overlay{
            border-bottom: 1px solid rgba(0, 0, 0, 0.04)!important;
        } */
        .status-overlay{
            // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
    }
</style>
<style lang="scss">
.status-overlay-navbar{
    .v-toolbar__content{
        padding: 0!important;
        align-items: start!important;
    }
}
</style>